<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="$router.push('/administrator/pi-action-config-add.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`${item.id}/pi-action-config-update.html`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2";
import BaseSwitch from "../base/BaseSwitch";
import BaseTextArea from "../base/BaseTextArea";
import BaseFormLoading from "../base/BaseFormLoading";
import RangeSlider from 'vue-range-slider'
import { USER_NAME } from '../../constant';

export default {
  name: "PiActionConfigList",
  components: {BaseTable, BaseInput, BaseSelect, BaseSwitch, ModalConfirm, BaseTextArea, BaseFormLoading, RangeSlider},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/pi-action-config/delete-by-id",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "thao tác",
          that.actionData.model.actionName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.actionId,
          userName: localStorage.getItem(USER_NAME)
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa thao tác " + that.actionData.model.actionName + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      loading: {value: false},
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          actionId: null,
          actionName: null
        }
      },
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      mainTable: {
        options: {
          fields: [
            // {key: "index", label: "STT"},
            {key: "value", label: "Mã thao tác"},
            {key: "name", label: "Tên thao tác"},
            {key: "cmd", label: "Câu lệnh"},
            {key: "action", label: "Thao tác"},
          ],
          slots: ["index", "action"],
          // lazyLoad: this.$hasAuthor('ROLE_WARD') ? true : false
        },
        dataSource: {
          url: "/pi-action-config/getPages",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter, isLoading) {
      this.$refs.mainTable.loadData( isUpdateFilter, isLoading);
    },
    setupSelectOneAction: function (actionTypeKey, actionId, actionName) {
      let actionData = this.actionData.model;
      actionData.actionId = actionId || null;
      actionData.actionName = actionName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style lang="scss">
@import '~vue-range-slider/dist/vue-range-slider.scss';

.slider {
  width: 200px;
  max-width: 200px;
  padding: 0 !important;
}

.range-slider-rail, .range-slider-fill {
  height: 6px !important;
}

.range-slider-fill {
  background-color: #0b98ff;
}

.range-slider-knob {
  width: 15px !important;
  height: 15px !important;
}
</style>
